// extracted by mini-css-extract-plugin
export default {"mCard":"wv-z","image":"xv-z","imageNoBackground":"yv-z","imageHasCategory":"zv-z","fullWidth":"Av-z"};